import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

const Wrapper = styled.div`
    display: flex;
    align-items: center;

    width: 75%;
    color: var(--darkgreen);

    text-transform: capitalize;

    white-space: pre;
    font-family: IBM Plex Mono Regular;
    z-index: 2;

    .item{
        padding: 5px;
        border-radius: 10px;

        &:hover{
            background-color: rgba(0, 0, 0, 0.05);
        }
    }

    p{
        margin: 0;
    }

    @media(max-widtH: 1000px)
    {
        width: 90%;
        font-size: 1.75vh;
    }
`;

export default function Breadcrumbs({ product })
{

    return(
        <Wrapper>
            <Link to="/menu">
                <p className="item">
                    {'All Items'}
                </p>
            </Link>

            <p>
                {product?.category ? '>' : ''}
            </p>

            {product?.category && <Link to={`/menu/${product.category.toLowerCase()}`}>
                <p className="item">
                    {product.category.toLowerCase().replace("_", " ")}
                </p>
            </Link>}

            <p>
                {product?.subcategory ? '>' : ''}
            </p>

            {product?.subcategory && <Link to={`/menu/${product.category.toLowerCase()}/${product?.subcategory?.toLowerCase()}`}>
                <p className="item">
                    {product?.subcategory ? product?.subcategory?.toLowerCase().replace("_", " ") : ''}
                </p>
            </Link>}
        </Wrapper>
    )

}